import { getLanguage, setLanguage, t } from '../lib/i18n.js';
import {
  RIGHTS_TERMS_VERSION,
  rightsTermsContent,
} from '../lib/rightsTerms.js';

export async function renderRightsHolderTerms() {
  renderTermsPage();
}

function renderTermsPage() {
  const app = document.getElementById('app');
  const language = getLanguage() === 'en' ? 'en' : 'fo';
  const terms = rightsTermsContent[language];

  app.innerHTML = `
    <main class="admin-main legal-main">
      <div class="legal-shell">
        <div class="legal-toolbar">
          <a href="/upload" class="btn btn-secondary btn-small" data-link>${t('rights_terms_back_upload')}</a>
          <div class="language-selector legal-language-selector" aria-label="${t('settings_language')}">
            <button type="button" class="language-btn ${language === 'fo' ? 'active' : ''}" data-terms-lang="fo">
              ${t('settings_language_fo')}
            </button>
            <button type="button" class="language-btn ${language === 'en' ? 'active' : ''}" data-terms-lang="en">
              ${t('settings_language_en')}
            </button>
          </div>
        </div>

        <article class="legal-content">
          <p class="legal-version">${escapeHtml(terms.updatedLabel)} ${RIGHTS_TERMS_VERSION}</p>
          <h1>${escapeHtml(terms.title)}</h1>
          <p class="legal-subtitle">${escapeHtml(terms.subtitle)}</p>
          ${language === 'en' ? `<p class="legal-note">${t('rights_terms_draft_notice')}</p>` : ''}
          <p class="legal-intro">${escapeHtml(terms.intro)}</p>
          ${terms.sections.map(renderSection).join('')}
        </article>
      </div>
    </main>
  `;

  document.querySelectorAll('[data-terms-lang]').forEach((button) => {
    button.addEventListener('click', () => {
      setLanguage(button.getAttribute('data-terms-lang'));
      renderTermsPage();
    });
  });
}

function renderSection(section) {
  return `
    <section class="legal-section">
      <h2>${escapeHtml(section.title)}</h2>
      ${(section.paragraphs || []).map((paragraph) => `<p>${escapeHtml(paragraph)}</p>`).join('')}
      ${
        section.bullets
          ? `
        <ul>
          ${section.bullets.map((bullet) => `<li>${escapeHtml(bullet)}</li>`).join('')}
        </ul>
      `
          : ''
      }
      ${section.closing ? `<p>${escapeHtml(section.closing)}</p>` : ''}
    </section>
  `;
}

function escapeHtml(value) {
  const div = document.createElement('div');
  div.textContent = value || '';
  return div.innerHTML;
}
